import { ICoupon } from "@alpha/types";
import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef } from "@angular/core";
import { AppLogger, Button, FilterType, IFilterItem, RadioButton } from "app-core";
import { CouponService, UIUtilService } from "app-service";
import { Subject, takeUntil } from "rxjs";

import ButtonType = Data.Core.ButtonType;
import IconType = Data.Core.IconType;

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
  viewProviders: [CouponService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CouponsComponent implements OnInit {
  public ngUnsubscribe = new Subject<void>();
  public coupons: Array<Partial<ICoupon>> = [];
  public noCoupons: boolean = true;
  public filterItems: Array<IFilterItem> = [];
  public radioFilter: FilterType = 'RadioButton';
  private selectedFilter: number = 1;
  public showFiltersButton: Button = new Button({
    label: 'Filters',
    type: ButtonType.flatButton,
    icon: IconType.filterIcon,
    action: () => this._showFilters(),
  });
  public timeFilterItems: Array<RadioButton> = [
    {
      label: `Active`,
      value: 1,
      checked: true
    },
    {
      label: `Inactive`,
      value: 2
    },
  ];

  public constructor(
    public readonly _cdRef: ChangeDetectorRef,
    private readonly couponService: CouponService,
    private readonly _uiUtilService: UIUtilService,
  ) {
  }

  public ngOnInit(): void {
    this.getCouponsByFilter(this.selectedFilter);

    this._addFilters();
    this._uiUtilService.isNavbarOpened.next(false);
  }

  private _showFilters(): void {
    this._uiUtilService.isNavbarOpened.next(true);
  }

  private _addFilters(): void {
    this.filterItems.push(
      {
        title: 'Filter By Coupon Status',
        filters: {
          list: () => this.timeFilterItems,
          type: this.radioFilter
        },
        onItemSelected: (id: any) => {
          this.selectedFilter = id.value;
          this.getCouponsByFilter(this.selectedFilter);
        },
        selectedItem: this.timeFilterItems[0].value,
        expanded: true
      }
    );
  }

  private getCouponsByFilter(selectedFilter: number): void {
    this.couponService.getCouponsByFilter(selectedFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (couponList) => {
          this.coupons = couponList;
          this.noCoupons = false;
        }, (err) => {
          AppLogger.Warning(`Failed to fetch coupons; Error:${err}`);
        },
        () => {
          this._cdRef.markForCheck();
        }
      );
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
